<template>
  <div>
    <el-drawer
      title="唯格云文章同步器"
      :visible.sync="showDrawer"
      direction="btt"
      size="90%"
      append-to-body
      @closed="onClose"
    >
      <el-table
        :data="tableData"
        border
        :style="tableStyle"
        :size="tableSize"
        header-cell-class-name="baseTableHeadStyle"
        ref="multipleTable"
        row-class-name="customs-table-row"
        v-loading="tableLoading"
        element-loading-text="查询中..."
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <el-table-column type="index" align="center" width="50" />
        <template v-for="column in tableColumns">
          <el-table-column
            v-if="column.showColumn"
            v-bind="column"
            :show-overflow-tooltip="true"
            :key="column.prop"
          >
            <template slot-scope="scope">
              <el-image
                v-if="column.prop === 'description_image_url'"
                style="width: 66px; height: 66px;"
                :src="scope.row.description_image_url"
                :preview-src-list="[scope.row.description_image_url]"
              >
              </el-image>
              <span v-else-if="column.prop === 'utc_post'">{{
                scope.row.utc_post | date_time
              }}</span>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="custom-table-footer">
        <el-pagination
          class="base-table-pagination"
          :disabled="tableLoading"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page + 1"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button
          class="mt-r"
          size="small"
          type="primary"
          icon="el-icon-circle-check"
          @click="handleConfrim"
          :loading="submitting"
          >{{ submitting ? "添加中..." : "添加选中项" }}</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ShowApiError } from "@/request/error";
import { GetArticlesList } from "../api/viewgres_v4";
import { replaceCdnAddress } from "@/utils/common";
import { PostArticle } from "../api/index";
import form from "../mixins/form";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [form],
  data() {
    return {
      tableStyle: {
        width: "100%",
      },
      tableSize: "medium",
      tableLoading: false,

      tableColumns: [],
      page: 0,
      size: 20,
      total: 0,
      tableData: [],
      orderProp: "utc_post",
      orderDirection: "descending",
      selections: [],
      showDrawer: false,
      submitting: false,
    };
  },
  watch: {
    show: {
      handler(value) {
        this.showDrawer = value;
        if (this.showDrawer) {
          this.getTableData();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.buildTableColumns();
  },
  methods: {
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "typeName",
            label: "类型",
            showColumn: true,
            minWidth: 100,
            align: "center",
            sortable: "custom",
          },
          {
            prop: "title",
            label: "标题",
            showColumn: true,
            minWidth: 150,

            sortable: "custom",
          },
          {
            prop: "utc_post",
            label: "发布时间",
            minWidth: 120,
            align: "center",
            showColumn: true,
            sortable: "custom",
          },
          {
            prop: "descriptionText",
            label: "描述",
            minWidth: 150,
            showColumn: true,
            sortable: "custom",
          },
          {
            prop: "description_image_url",
            label: "描述图片",
            width: 120,
            align: "center",
            showColumn: true,
            sortable: "custom",
          },

          {
            prop: "referenceUrl",
            label: "引用地址",
            align: "center",
            showColumn: true,
            minWidth: 120,
            sortable: "custom",
          },
          {
            prop: "poster_image_url",
            label: "海报图片",
            showColumn: true,
            minWidth: 130,
            align: "center",
            sortable: "custom",
          },
          {
            prop: "posterSlogan",
            label: "海报标语",
            align: "left",
            showColumn: true,
            width: 120,
            sortable: "custom",
          },
          {
            prop: "content",
            label: "内容",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom",
          },
          {
            prop: "user_name_create",
            label: "创建人",
            align: "left",
            showColumn: true,
            width: 120,
            sortable: "custom",
          },
          {
            prop: "utc_create",
            label: "创建日期",
            align: "center",
            showColumn: true,
            width: 130,
            sortable: "custom",
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            width: 120,
            align: "center",
            showColumn: true,
            sortable: false,
          },
          {
            prop: "utc_modified",
            label: "更新日期",
            align: "center",
            showColumn: true,
            width: 130,
            sortable: "custom",
          },

          {
            prop: "id",
            label: "ID",
            align: "left",
            showColumn: true,
            width: 100,
            sortable: "custom",
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 80,
          },
        ];
      }
    },
    getTableData() {
      this.tableLoading = true;
      GetArticlesList({
        page: this.page,
        size: this.size,
        sort: `postAt,desc`,
      })
        .then((res) => {
          let { content, totalElements } = res.data;
          this.tableData = content;

          this.total = totalElements;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;

          ShowApiError(err, "拉取列表错误");
        });
    },
    handleSelectionChange(selections) {
      this.selections = selections;
      this.$emit("onSelectionChange", selections);
    },
    handleConfrim() {
      if (this.selections.length === 0) {
        this.$message.warning("请选择要添加的文章");
        return;
      }
      this.$confirm("是否确认将选中文章新增到系统?", "确认提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            console.log("选中的文章", this.selections);
            this.submitting = true;
            let formDatas = [];
            // PostArticle
            this.selections.forEach((element) => {
              let form = this.buildFormItem();
              form.title.cn = element.title;
              form.title.en = element.title;
              form.description.cn = element.descriptionText;
              form.description.en = element.descriptionText;
              form.description_image_url = replaceCdnAddress(
                element.description_image_url
              );
              form.referenceUrl = element.referenceUrl;
              form.poster_image_url = replaceCdnAddress(
                element.poster_image_url
              );
              form.posterSlogan.cn = element.posterSlogan;
              form.posterSlogan.en = element.posterSlogan;
              form.seq = 1;
              form.utc_post = element.postMillisecond;
              form.content.cn = element.content;
              form.content.en = element.content;
              form.tagIds = [this.typeMaper[element.typeId]];
              formDatas.push(form);
            });
            console.log("创建的表单数据", formDatas);
            await PostArticle(formDatas);
            this.$message({
              type: "success",
              message: "同步成功",
            });
          } catch (error) {
            ShowApiError("同步失败", error);
          } finally {
            this.submitting = false;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onClose() {
      this.showDrawer = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-table-footer {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
}
</style>
